module.exports = __webpack_public_path__ + "img/em-rail-ejector.f3a6aa34.png";